import { render, staticRenderFns } from "./ContractsList.vue?vue&type=template&id=78092382&"
import script from "./ContractsList.vue?vue&type=script&lang=ts&"
export * from "./ContractsList.vue?vue&type=script&lang=ts&"
import style0 from "./ContractsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports